var Vendd = (function (Vendd) {
    'use strict';
    
    Vendd.Order = (function (Order) {

        Order.Messages = (function (Messages) {

        Messages.CancelUncompletedOrder = function (orderId) {
            var data = {
                orderId: orderId
            };

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Order.Messages.CancelUncompletedOrder', data);
        };
        Messages.CancelUncompletedOrder.className = 'Vendd.Order.Messages.CancelUncompletedOrder';

        Messages.CancelUncompletedOrderSuccess = function (model) {
            var data = {
                model: model
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.Order.Messages.CancelUncompletedOrderSuccess", data);
        };
        Messages.CancelUncompletedOrderSuccess.className = 'Vendd.Order.Messages.CancelUncompletedOrderSuccess';

        Messages.CancelUncompletedOrderFailed = function (response) {
            response.data = JSON.parse(response.data);
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.Order.Messages.CancelUncompletedOrderFailed", response);
        };
        Messages.CancelUncompletedOrderFailed.className = "Vendd.Order.Messages.CancelUncompletedOrderFailed";

        Messages.ReturnOrderItem = function (orderItemId) {
            var data = {
                orderItemId: orderItemId
            };

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Order.Messages.ReturnOrderItem', data);
        };
        Messages.ReturnOrderItem.className = 'Vendd.Order.Messages.ReturnOrderItem';

        Messages.ReturnOrderItemSuccess = function (model) {
            var data = {
                model: model
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.Order.Messages.ReturnOrderItemSuccess", data);
        };
        Messages.ReturnOrderItemSuccess.className = 'Vendd.Order.Messages.ReturnOrderItemSuccess';

        Messages.ReturnOrderItemFailed = function (response) {
            response.data = JSON.parse(response.data);
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.Order.Messages.ReturnOrderItemFailed", response);
        };
        Messages.ReturnOrderItemFailed.className = "Vendd.Order.Messages.ReturnOrderItemFailed";

        Messages.SubmitRequestOrderChange = function (observable) {
            var data = {
                model: observable.model
            };

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Order.Messages.SubmitRequestOrderChange', data);
        };
        Messages.SubmitRequestOrderChange.className = 'Vendd.Order.Messages.SubmitRequestOrderChange';

        Messages.SubmitRequestOrderChangeSuccess = function (response) {
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Order.Messages.SubmitRequestOrderChangeSuccess', response);
        };
        Messages.SubmitRequestOrderChangeSuccess.className = 'Vendd.Order.Messages.SubmitRequestOrderChangeSuccess';

        Messages.SubmitRequestOrderChangeFailure = function (response) {
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Order.Messages.SubmitRequestOrderChangeFailure', response);
        };
        Messages.SubmitRequestOrderChangeFailure.className = 'Vendd.Order.Messages.SubmitRequestOrderChangeFailure';

        return Messages;

    })(Order.Messages || {});

        return Order;

    })(Vendd.Order || {});

return Vendd;

})(Vendd || {});